

import firebase from 'firebase'
export const Reducer = (state, action)=>{
    switch (action.type) {
        case 'DELETE_CARD':
            return {
                ...state,
                cards: state.cards.filter(card => card.id !== action.payload)
            };
        case 'ADD_CARD':
            return {
                ...state,
                cards: [action.payload, ...state.cards]
            };
        case 'UPDATE_CARD':
            return {
                ...state,
                cards: state.cards.map(card =>
                    card.id === action.payload.id ? (card = action.payload) : card
                )
            };
        case 'AUTH_LOGIN':
            return {
                ...state,
                auth: action.payload
            };
        case 'ONAME_CASE':
            return {
                ...state,
                oid: action.payload
            };
        case 'AUTH_LOGOUT':
            firebase.auth().signOut();
            localStorage.removeItem('token');
            localStorage.removeItem('expDate');
            localStorage.removeItem('userId');
            return {
                ...state,
                auth: action.payload,
                cards: []
            };
        default:
            return state;
    }
};


